<template>
  <article class="detailsArticle">
    <header class="detailsArticleHeader">
      <div class="detailsArticleHeaderEyecatch">
        <img :src="postThumbnail" alt="" />
      </div>
      <h1>{{ post.title }}</h1>
      <h2>{{ post.subtitle }}</h2>
      <footer class="detailsArticleFooter">
        <p class="detailsArticleDate">
          <i class="material-icons">access_time</i> {{ dispPublishedAt }}
        </p>
        <p class="detailsArticleAuthor">
          <i class="material-icons">rss_feed</i>{{ post.source.name }}
        </p>
      </footer>
    </header>
    <div class="detailsArticleContents">
      <div class="textbox excerpt tiny-textbox" v-html="post.excerpt"></div>

      <div
        v-if="seminarId && !seminarIsInWeb"
        class="detailsArticleApplication"
      >
        <p v-if="isClosed" class="second">本セミナーは終了しました</p>
        <p v-else-if="isNotStarted" class="second">
          申込期間は{{ reservationPeriod }}です
        </p>
        <p v-else-if="isReserved" class="second">
          <a :href="'/seminars/' + seminarId + '/confirm'" class="btn"
            >お申し込み内容の確認</a
          >
        </p>
        <p v-else-if="canReserved" class="second">
          <a :href="'/seminars/' + seminarId + '/reserve'" class="btn key"
            >お申し込みはこちら</a
          >
        </p>
        <p v-else class="second">申し込みは終了しました</p>
      </div>

      <div class="textbox">
        <div
          class="tiny-textbox tiny-textboxBody"
          v-show="showBody"
          v-html="post.body"
        ></div>

        <div class="detailsArticleReadmore" v-show="hasPdf && showBody">
          <a
            v-if="isPreview"
            :href="'/posts/' + post.id + '/pdf?status=preview'"
            :class="{ btnReadMore: true }"
            target="_blank"
          >
            PDFを<br class="sp" />閲覧する
          </a>
          <a
            v-else-if="scopeAll"
            :href="'/posts/' + post.id + '/pdf?status=scopeAll'"
            :class="{ btnReadMore: true }"
            target="_blank"
          >
            PDFを<br class="sp" />閲覧する
          </a>
          <a
            v-else-if="scopeStandard"
            :href="'/posts/' + post.id + '/pdf?status=scopeStandard'"
            :class="{ btnReadMore: true }"
            target="_blank"
          >
            PDFを<br class="sp" />閲覧する
          </a>
          <a
            v-else-if="showPdfPremium"
            :href="'/posts/' + post.id + '/pdf?status=scopePremium'"
            :class="{ btnReadMore: true }"
            target="_blank"
          >
            PDFを<br class="sp" />閲覧する
          </a>
        </div>

        <!-- ★ここだけ変更：キュレーション時は本文表示後もボタンエリアを残す -->
        <div class="detailsArticleReadmore" v-show="!showBody || isCuration">
          <template v-if="isPreview">
            <div class="readmoreStackWrap">
              <div class="readmoreStack">
                <!-- 続きボタン：キュレーション含め、本文未表示時だけ表示 -->
                <span
                  v-if="hasBody && !showBody"
                  @click="addPost"
                  :class="{
                    btnReadMore: true,
                    readmoreStack__readBtn: true
                  }"
                >
                  <span v-show="hasPdf">Webで<br class="sp"/></span>つづきを読む
                </span>
                <!-- キュレーション：オリジナルサイトへ（常に表示） -->
                <a
                  v-if="isCuration"
                  :href="'' + post.rss_link"
                  target="_blank"
                  :class="{ mlauto: true, btnReadMore: true }"
                >
                  オリジナルサイトへ
                </a>
                <!-- 非キュレーションの詳細リンク（本文未表示時のみ） -->
                <a
                  v-else-if="hasInsiteLink && !showBody"
                  :href="'' + post.insite_link"
                  :class="{ mlauto: true, btnReadMore: true }"
                >
                  詳細はこちら
                </a>
              </div>
            </div>
          </template>

          <template v-else-if="scopeAll">
            <div class="detailsArticleReadmorePremium">
              <!-- 続きボタン：本文未表示時だけ -->
              <span
                v-if="hasBody && !showBody"
                @click="addPost"
                :class="{
                  btnReadMore: true,
                  readmoreStack__readBtn: true
                }"
              >
                <span v-show="hasPdf">Webで<br class="sp"/></span>つづきを読む
              </span>
              <!-- キュレーション：オリジナルサイトへ（常に表示） -->
              <a
                v-if="isCuration"
                :href="'' + post.rss_link"
                target="_blank"
                :class="{
                  mlauto: true,
                  btnReadMore: true,
                  bgNone: true
                }"
              >
                オリジナルサイトへ
              </a>
              <!-- 非キュレーション：本文未表示時のみ詳細リンク -->
              <a
                v-else-if="hasInsiteLink && !showBody"
                :href="'' + post.insite_link"
                :class="{
                  mlauto: true,
                  btnReadMore: true,
                  bgNone: true
                }"
              >
                詳細はこちら
              </a>
              <template v-if="frd && !loggedIn">
                <p class="mt30" style="font-size: 14px;">
                  NCB Libraryをご利用のあなたにオススメ!
                </p>

                <div
                  class="detailsArticlePremiumCourseDescription"
                  @click="moveFreeRegister"
                >
                  <p class="detailsArticlePremiumCourseDescriptionTitle">
                    {{ frd.title }}
                  </p>
                  <p class="detailsArticlePremiumCourseDescriptionSubTitle">
                    {{ frd.body }}
                  </p>

                  <v-container>
                    <v-layout row wrap>
                      <v-flex
                        class="detailsArticlePremiumCourseDescriptionColumns"
                      >
                        <div class="tiny-textbox" v-html="frd.column_1"></div>
                      </v-flex>
                      <v-flex
                        class="detailsArticlePremiumCourseDescriptionColumns"
                      >
                        <div class="tiny-textbox" v-html="frd.column_2"></div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <p class="detailsArticleReadmoreFreeBtnTextOne">
                    無料で会員登録
                  </p>
                  <p
                    class="detailsArticlePremiumCourseDescriptionReadMMore bgNone"
                    style="text-align: right;"
                  >
                    <a
                      :href="this.navigationPostLinkForPlanInfo"
                      class="bgNone"
                      style="text-align: right; color: rgb(0, 66, 189); border: none; font-size: 12px;"
                    >
                      NCB
                      Libraryをすべて楽しめる「プレミアム会員」もございます。
                      <br class="pc" />詳しくはこちら→
                    </a>
                  </p>
                </div>
              </template>
            </div>
          </template>

          <template v-else-if="scopeStandard">
            <template v-if="!loggedIn">
              <div class="detailsArticleReadmorePremium">
                <p class="detailsArticleReadmorePremiumDesc">
                  この続きは、NCB Libraryスタンダード会員(無料)<br />への登録で閲覧できます
                </p>
                <a
                  href="/register"
                  class="detailsArticleReadmoreStandardBtnTextOne"
                >
                  <p class="detailsArticleReadmorePremiumBtnTextOne">
                    無料で会員登録
                  </p>
                </a>

                <p class="detailsArticleReadmoreLogin">
                  すでにスタンダード、プレミアム会員の方は
                </p>
                <p class="detailsArticleReadmoreLoginLink">
                  <a class="detailsArticleReadmoreLoginLinkBtn2" href="/login">
                    ログイン
                  </a>
                </p>

                <div
                  class="detailsArticlePremiumCourseDescription"
                  @click="moveStandardRegister"
                  v-if="srd"
                >
                  <p class="detailsArticlePremiumCourseDescriptionTitle">
                    {{ srd.title }}
                  </p>
                  <p class="detailsArticlePremiumCourseDescriptionSubTitle">
                    {{ srd.body }}
                  </p>

                  <v-container>
                    <v-layout row wrap>
                      <v-flex
                        class="detailsArticlePremiumCourseDescriptionColumns"
                      >
                        <div class="tiny-textbox" v-html="srd.column_1"></div>
                      </v-flex>
                      <v-flex
                        class="detailsArticlePremiumCourseDescriptionColumns"
                      >
                        <div class="tiny-textbox" v-html="srd.column_2"></div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <p
                    class="detailsArticlePremiumCourseDescriptionReadMMore bgNone"
                    style="text-align: right;"
                  >
                    <a
                      :href="this.navigationPostLinkForPlanInfo"
                      class="bgNone"
                      style="text-align: right; color: rgb(0, 66, 189); border: none; font-size: 12px;"
                    >
                      NCB
                      Libraryをすべて楽しめる「プレミアム会員」もございます。
                      <br class="pc" />詳しくはこちら→
                    </a>
                  </p>
                </div>
              </div>
            </template>

            <!-- ログイン済みスタンダード会員 -->
            <template v-else>
              <div class="readmoreStackWrap">
                <div class="readmoreStack">
                  <!-- 続きボタン：本文未表示時のみ -->
                  <span
                    v-if="hasBody && !showBody"
                    @click="addPost"
                    :class="{
                      btnReadMore: true,
                      readmoreStack__readBtn: true
                    }"
                  >
                    <span v-show="hasPdf">Webで<br class="sp"/></span
                    >つづきを読む
                  </span>
                  <!-- キュレーション：オリジナルサイトへ（常に表示） -->
                  <a
                    v-if="isCuration"
                    :href="'' + post.rss_link"
                    target="_blank"
                    :class="{ mlauto: true, btnReadMore: true }"
                  >
                    オリジナルサイトへ
                  </a>
                  <!-- 非キュレーション詳細リンク（本文未表示時） -->
                  <a
                    v-else-if="hasInsiteLink && !showBody"
                    :href="'' + post.insite_link"
                    :class="{ mlauto: true, btnReadMore: true }"
                  >
                    詳細はこちら
                  </a>
                </div>
              </div>
            </template>
          </template>

          <template v-else-if="scopeLb">
            <!-- 未ログイン or 受講権限なし：注意文を出す -->
            <span v-if="!loggedIn || !lbOpen" class="detailsArticleReadmoreLb">
              当コンテンツは、金融eラーニングの当該コースを受講・または完了した方のみ閲覧できます。
            </span>

            <!-- 受講権限あり & キュレーションならオリジナルサイトへ（必要なら） -->
            <a
              v-else-if="isCuration"
              :href="'' + post.rss_link"
              target="_blank"
              :class="{ btnReadMore: true }"
            >
              オリジナルサイトへ
            </a>
          </template>

          <template v-else>
            <template v-if="!loggedIn || !isPremiumUser">
              <div class="detailsArticleReadmorePremium">
                <p class="detailsArticleReadmorePremiumDesc">
                  この続きは、NCB Libraryプレミアム会員<br />へのご登録で閲覧できます
                </p>
                <a href="/register/plan_select">
                  <p
                    class="detailsArticleReadmorePremiumBtnTextOne"
                    v-if="trialNum == 0"
                  >
                    つづきを読む
                  </p>
                  <p class="detailsArticleReadmorePremiumBtnTextOne" v-else>
                    {{ trialNum }}日間の無料トライアルに登録
                  </p>
                </a>

                <template v-if="!this.loggedIn">
                  <p class="detailsArticleReadmoreLogin">
                    すでにプレミアム会員の方は
                  </p>
                  <p class="detailsArticleReadmoreLoginLink">
                    <a
                      class="detailsArticleReadmoreLoginLinkBtn2"
                      href="/login"
                    >
                      ログイン
                    </a>
                  </p>
                </template>

                <div
                  class="detailsArticlePremiumCourseDescription"
                  @click="movePremiunCourseDescription"
                  v-if="pcd"
                >
                  <p class="detailsArticlePremiumCourseDescriptionTitle">
                    {{ pcd.title }}
                  </p>
                  <p class="detailsArticlePremiumCourseDescriptionSubTitle">
                    {{ pcd.body }}
                  </p>

                  <v-container>
                    <v-layout row wrap>
                      <v-flex
                        class="detailsArticlePremiumCourseDescriptionColumns"
                      >
                        <div class="tiny-textbox" v-html="pcd.column_1"></div>
                      </v-flex>
                      <v-flex
                        class="detailsArticlePremiumCourseDescriptionColumns"
                      >
                        <div class="tiny-textbox" v-html="pcd.column_2"></div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex
                        class="detailsArticlePremiumCourseDescriptionColumns"
                      >
                        <div class="tiny-textbox" v-html="pcd.column_3"></div>
                      </v-flex>
                      <v-flex
                        class="detailsArticlePremiumCourseDescriptionColumns detailsArticlePremiumCourseDescriptionColumnsLastBorder"
                      >
                        <div class="tiny-textbox" v-html="pcd.column_4"></div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <p class="detailsArticlePremiumCourseDescriptionReadMMore">
                    詳しくはこちら
                  </p>
                </div>
              </div>
            </template>

            <!-- プレミアム会員で閲覧可能な場合 -->
            <template v-else>
              <div class="readmoreStackWrap">
                <div class="readmoreStack">
                  <!-- 続きボタン：本文未表示時のみ -->
                  <span
                    v-if="hasBody && !showBody"
                    @click="addPost"
                    :class="{
                      btnReadMore: true,
                      readmoreStack__readBtn: true
                    }"
                  >
                    <span v-show="hasPdf">Webで<br class="sp"/></span
                    >つづきを読む
                  </span>
                  <!-- キュレーション：オリジナルサイト（常に表示） -->
                  <a
                    v-if="isCuration"
                    :href="'' + post.rss_link"
                    target="_blank"
                    :class="{ mlauto: true, btnReadMore: true }"
                  >
                    オリジナルサイトへ
                  </a>
                  <!-- 非キュレーション詳細リンク：本文未表示時のみ -->
                  <a
                    v-else-if="hasInsiteLink && !showBody"
                    :href="'' + post.insite_link"
                    :class="{ mlauto: true, btnReadMore: true }"
                  >
                    詳細はこちら
                  </a>
                </div>
              </div>
            </template>
          </template>
        </div>
        <br />
        <tags
          :tags="post.tags"
          class="detail-tags"
          v-show="isCuration || showBody"
        ></tags>
      </div>

      <div class="textbox mt30" v-if="isFintechReport && post.price > 0">
        <div class="detailsArticleReadMore text-xs-right">
          <a :href="'/orders/report/?reportType=fintech_report&id=' + post.id"
            >書籍（紙媒体）でレポートを購入する</a
          >
        </div>
      </div>

      <div class="detailsArticleShare">
        <ul>
          <li>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a href="javascript:void(0);" v-on="on" @click="shareTwitter">
                  <img src="/images/x-logo-black.png" class="sns-icon-small" />
                </a>
              </template>
              <span>Xでポスト</span>
            </v-tooltip>
          </li>
          <li>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a href="javascript:void(0);" v-on="on" @click="shareFacebook">
                  <i class="fab fa-facebook"></i>
                </a>
              </template>
              <span>Facebookでシェア</span>
            </v-tooltip>
          </li>
        </ul>
      </div>
    </div>
  </article>
</template>

<script>
import Tags from "./Tags.vue";

export default {
  components: {
    Tags
  },

  props: [
    "post",
    "shareUrl",
    "postThumbnail",
    "dispPublishedAt",
    "excerpt",
    "body",
    "isCuration",
    "isPreview",
    "loggedIn",
    "scopePremium",
    "scopeStandard",
    "scopeAll",
    "scopeLb",
    "hasPdf",
    "hasBody",
    "hasInsiteLink",
    "isPremiumUser",
    "isFintechReport",
    "forceOpen",
    "lbOpen",
    "seminarId",
    "seminarIsInWeb",
    "isClosed",
    "isReserved",
    "isNotStarted",
    "reservationPeriod",
    "canReserved",
    "trialNum",
    "freeRegisterDescription",
    "standardRegisterDescription",
    "premiumCourseDescription",
    "navigationPostLinkForPlanInfo"
  ],

  data() {
    return {
      shareWindow: {
        width: 600,
        height: 300
      },
      showBody: this.forceOpen,
      showLb: this.lbOpen,
      isHalf: this.isCuration || this.hasInsiteLink || this.hasBody,
      showPdfStandard: this.hasPdf && this.loggedIn,
      showPdfPremium: this.hasPdf && this.isPremiumUser,
      displayPost: [],
      frd: this.freeRegisterDescription
        ? JSON.parse(this.freeRegisterDescription)
        : null,
      srd: this.standardRegisterDescription
        ? JSON.parse(this.standardRegisterDescription)
        : null,
      pcd: this.premiumCourseDescription
        ? JSON.parse(this.premiumCourseDescription)
        : null
    };
  },
  mounted() {
    if (!this.loggedIn && !this.scopeAll && !this.isPreview) {
      return;
    }

    if (!this.isPremiumUser && this.scopePremium && !this.isPreview) {
      return;
    }

    if (this.scopeLb && !this.lbOpen && !this.isPreview) {
      return;
    }

    if (!localStorage.getItem("post_id")) {
      if (this.showBody) {
        this.addPost();
      }
      return;
    }

    try {
      this.displayPost = JSON.parse(localStorage.getItem("post_id"));
    } catch (e) {
      localStorage.removeItem("post_id");
    }

    if (this.showBody) {
      this.addPost();
      return;
    }

    // localstorageに記事idがあれば本文表示
    if (
      this.displayPost.length > 0 &&
      this.displayPost.includes(this.post.id)
    ) {
      this.showBody = true;
    }

    if (this.scopeLb && this.lbOpen) {
      this.showBody = true;
    } else if (this.isPreview && this.scopeLb) {
      this.showBody = true;
    }
  },

  methods: {
    addPost() {
      if (!this.loggedIn && !this.scopeAll && !this.isPreview) {
        return;
      }

      if (!this.isPremiumUser && this.scopePremium && !this.isPreview) {
        return;
      }

      // localstorageに記事idを追加
      if (!this.displayPost.includes(this.post.id)) {
        this.displayPost.push(this.post.id);
        const posts = JSON.stringify(this.displayPost);
        localStorage.setItem("post_id", posts);
      }

      this.showBody = true;
    },

    shareTwitter() {
      const url = "https://twitter.com/share?url=" + this.shareUrl;
      const left = Number((window.screen.width - this.shareWindow.width) / 2);
      const top = Number((window.screen.height - this.shareWindow.height) / 2);

      window.open(
        url,
        "twitter_window",
        "width=" +
          this.shareWindow.width +
          ", height=" +
          this.shareWindow.height +
          ", left=" +
          left +
          ", top=" +
          top +
          ", menubar=no, toolbar=no, scrollbars=yes"
      );
    },

    shareFacebook() {
      const url = "https://www.facebook.com/share.php?u=" + this.shareUrl;
      const left = Number((window.screen.width - this.shareWindow.width) / 2);
      const top = Number((window.screen.height - this.shareWindow.height) / 2);

      window.open(
        url,
        "facebook_window",
        "width=" +
          this.shareWindow.width +
          ", height=" +
          this.shareWindow.height +
          ", left=" +
          left +
          ", top=" +
          top +
          ", menubar=no, toolbar=no, scrollbars=yes"
      );
    },

    moveFreeRegister() {
      location.href = this.frd.url;
    },

    moveStandardRegister() {
      location.href = this.srd.url;
    },

    movePremiunCourseDescription() {
      location.href = this.pcd.url;
    }
  }
};
</script>

<style lang="scss" scoped>
.half {
  width: 48%;
  display: inline-block;
}

.mlauto {
  margin-left: auto;
}

.detail-tags {
  height: inherit !important;
}
.sns-icon-small {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
</style>
